import Card from "components/card";
import TimelineItem from "components/dataDisplay/TimelineItem";
const TimeLine = (props:any) => {
  const { eventDetails } = props;
  return (
    <Card extra={"w-full p-5"}>
    <div className="mt-[30px]">
      {eventDetails && eventDetails.map((event:any, index:string) => (
        <TimelineItem
          key={index} // Ideally, use a unique identifier like event.id
          title={event.title}
          email={event.email}
          day={event.day}
          weekday={event.weekday}
          hours={event.hours}
          mb="mb-[16px]"
          // Add 'current' prop conditionally if applicable
        />
      ))}
    </div>
  </Card>
  );
};

export default TimeLine;
